import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import find from 'lodash/find'

import * as login from '../../actions/userdetails'
import * as toaster from '../../actions/toaster'
import * as regData from '../../../appConstants'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: { user: null, oldpass: '', newpass: '', confirmnewpass: '' },
            setValue: false,
            isFileUploadSet: false,
            isFileDetailsUpdateSet: false,
        };
    }
    handleChange(field, e) {
        const data = Object.assign({}, this.state.data, { [field]: e.target.value });
        this.setState(Object.assign({}, this.state, { 'data': data }));
    }
    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        if (this.state.data.confirmnewpass == this.state.data.newpass) {
            this.props.handleSetChangePassword();
            this.props.actions.changepassword(this.state.data.oldpass, this.state.data.newpass)
            this.setState({ data: {user: this.props.loginUser.data, oldpass: '', newpass: '', confirmnewpass: '' } })
        }
        else
            this.props.actions.warningToasters("New Password and confirm password should be same");
    };

    render() {
        const { loginUser, userDetails } = this.props;
        let data = loginUser
        let result = null;

        let message = null;
        if (userDetails && userDetails.CPStatus)
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        // else if (userDetails && userDetails.CPResult)
        // this.props.closeDialog();


        if (!this.state.setValue && loginUser && loginUser.data) {
            this.state.data.user = loginUser.data;
            this.setState({ setValue: true });
            // console.log('changePassword Popup=>', this.state.data)
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Change Password</span>
                    </DialogTitle>
                    <DialogContent>
                        {message}
                        <div className="row p-4">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-12">
                                        To update your password, Enter Old Password, New Password and Confirm Nerw Password
                                    </div>
                                </div>
                                {this.state.data && this.state.data.user ?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ValidatorForm autoComplete="off" ref="changepasswordform" onSubmit={this.setData.bind(this)}>
                                                <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                    name="userId" label="User Id" disabled
                                                    value={this.state.data.user.user_id}
                                                />
                                                <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                    name="oldpass" label="Old Password" type="password"
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                    value={this.state.data.oldpass} onChange={this.handleChange.bind(this, 'oldpass')}
                                                />
                                                <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                    name="newpass" label="New Password" type="password"
                                                    validators={['required', regData.regexMinLength]}
                                                    errorMessages={['This field is required', regData.messageMinLength]}
                                                    value={this.state.data.newpass} onChange={this.handleChange.bind(this, 'newpass')}
                                                />
                                                <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                    name="confirmnewpass" label="Confirm New Password" type="password"
                                                    validators={['required', regData.regexMinLength]}
                                                    errorMessages={['This field is required', regData.messageMinLength]}
                                                    value={this.state.data.confirmnewpass} onChange={this.handleChange.bind(this, 'confirmnewpass')}
                                                />
                                            </ValidatorForm>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={() => this.refs.changepasswordform.submit()} variant="raised" className="jr-btn bg-primary text-white">Update</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, login, toaster), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);


// WEBPACK FOOTER //
// ./components/UserInfo/changepassword.js